import { useSpecialFunctions } from "../../functions";

const FieldChangesTable = ({ fieldChangesInfo }) => {
  const { getTimeInfo } = useSpecialFunctions();
  const headers = (
    <tr className="text-center">
      <th>Old Value</th>
      <th>New Value</th>
      <th>Modified By</th>
      <th>Last Modified</th>
      <th>Phone</th>
      <th>IP</th>
    </tr>
  );

  const fieldChangesTable =
    fieldChangesInfo.length > 0 ? (
      fieldChangesInfo.map((item, index) => {
        const placedDate = new Date(item.placeddate);
        const formattedDate = placedDate.toLocaleDateString("en-GB");
        const formattedTime = getTimeInfo(item.placeddate);

        return (
          <tr key={`${item.idtracklog || "row"}-${index}`}>
            {/* Old Value */}
            <td className="text-center align-middle">{item.oldvalue}</td>
            {/* New Value */}
            <td className="text-center align-middle">{item.newvalue}</td>
            {/* Modified By */}
            <td className="text-center align-middle">{item.loginname}</td>
            {/* Last Modified */}
            <td className="text-center align-middle">
              {formattedDate} {formattedTime}
            </td>
            {/* Phone */}
            <td className="text-center align-middle">{item.phoneline}</td>
            {/* IP */}
            <td className="text-center align-middle">{item.ip}</td>
          </tr>
        );
      })
    ) : (
      <tr>
        <td
          colSpan={8}
          style={{
            verticalAlign: "middle",
            textAlign: "center",
            color: "#8c8c8c",
          }}
        >
          No Field Changes to display
        </td>
      </tr>
    );

  return (
    <div style={{ maxHeight: "500px", overflow: "auto" }}>
      <table className="table table-striped table-sm mt-2">
        <thead style={{ position: "sticky", top: "0", background: "#d9d9d9" }}>
          {headers}
        </thead>
        <tbody className="table-lg">{fieldChangesTable}</tbody>
      </table>
    </div>
  );
};

export default FieldChangesTable;
